/**
 * Cart page logic.
 * Handles quantity +/-, item removal, and 5-or-10 checkout validation.
 * All changes go through Shopify Cart API.
 */
(function () {
  'use strict';

  function validate(cart) {
    var warning = document.getElementById('cart-warning');
    var checkoutBtn = document.getElementById('cart-checkout-btn');
    var targetSize = window.BundleManager.getTargetSize();

    var count = cart ? cart.item_count : 0;
    var giftCardOnly = window.BundleManager.isGiftCardOnly(cart);
    var canCheckout = giftCardOnly || (targetSize && count === targetSize);

    if (warning) {
      if (!giftCardOnly && targetSize && count > 0 && !canCheckout) {
        warning.style.display = 'block';
        var msg = warning.querySelector('.cart-warning-text');
        if (msg) {
          msg.textContent = 'You need exactly ' + targetSize + ' items to checkout. You currently have ' + count + '.';
        }
      } else {
        warning.style.display = 'none';
      }
    }

    if (checkoutBtn) {
      if (canCheckout) {
        checkoutBtn.disabled = false;
        checkoutBtn.classList.remove('btn--disabled');
      } else {
        checkoutBtn.disabled = true;
        checkoutBtn.classList.add('btn--disabled');
      }
    }
  }

  // Re-render the cart items section after AJAX changes
  function renderCart(cart) {
    var itemsContainer = document.getElementById('cart-items');
    var totalEl = document.getElementById('cart-total-price');
    var emptyEl = document.getElementById('cart-empty');
    var filledEl = document.getElementById('cart-filled');

    if (!cart || cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      if (filledEl) filledEl.style.display = 'none';
      validate(cart);
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (filledEl) filledEl.style.display = 'block';

    // Render items
    if (itemsContainer) {
      var html = '';
      cart.items.forEach(function (item) {
        var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_120x$1$2') : '';
        html += '<div class="cart-item" data-line-key="' + item.key + '">';
        html += '<div class="cart-item__image-wrap">';
        if (imgSrc) html += '<img src="' + imgSrc + '" alt="' + item.title.replace(/"/g, '&quot;') + '" width="120" height="120">';
        html += '</div>';
        html += '<div class="cart-item__info">';
        html += '<h3 class="cart-item__title">' + item.product_title + '</h3>';
        if (item.variant_title) html += '<p class="cart-item__variant">' + item.variant_title + '</p>';
        html += '<p class="cart-item__price">' + window.BundleManager.formatMoney(item.final_price) + '</p>';
        html += '</div>';
        html += '<div class="cart-item__qty">';
        html += '<button type="button" class="cart-qty-btn cart-qty-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '">−</button>';
        html += '<span class="cart-qty-value">' + item.quantity + '</span>';
        html += '<button type="button" class="cart-qty-btn cart-qty-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">+</button>';
        html += '</div>';
        html += '<div class="cart-item__total">' + window.BundleManager.formatMoney(item.final_line_price) + '</div>';
        html += '<button type="button" class="cart-item__remove" data-key="' + item.key + '" aria-label="Remove">×</button>';
        html += '</div>';
      });
      itemsContainer.innerHTML = html;
    }

    // Total
    if (totalEl) {
      totalEl.textContent = window.BundleManager.formatMoney(cart.total_price);
    }

    // Disable + buttons if at target size (skip for gift-card-only cart)
    var targetSize = window.BundleManager.getTargetSize();
    if (targetSize && cart.item_count >= targetSize && !window.BundleManager.isGiftCardOnly(cart)) {
      var plusBtns = document.querySelectorAll('.cart-qty-plus');
      plusBtns.forEach(function (btn) { btn.disabled = true; });
    }

    validate(cart);
  }

  var currentCart = null;

  // Wrap renderCart to track current cart
  var _origRenderCart = renderCart;
  renderCart = function (cart) {
    currentCart = cart;
    _origRenderCart(cart);
  };

  // Event delegation for quantity +/- and remove
  function initButtons() {
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.cart-qty-btn');
      if (qtyBtn) {
        e.preventDefault();
        var key = qtyBtn.dataset.key;
        var newQty = parseInt(qtyBtn.dataset.qty, 10);

        // Block increase if already at target (gift-card-only cart is exempt)
        if (qtyBtn.classList.contains('cart-qty-plus') && currentCart) {
          var targetSize = window.BundleManager.getTargetSize();
          if (targetSize && currentCart.item_count >= targetSize && !window.BundleManager.isGiftCardOnly(currentCart)) return;
        }

        if (newQty <= 0) {
          window.BundleManager.removeItem(key);
        } else {
          window.BundleManager.updateItem(key, newQty);
        }
        return;
      }

      var removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn) {
        e.preventDefault();
        window.BundleManager.removeItem(removeBtn.dataset.key);
        return;
      }
    });
  }

  // Loading state on cart items
  document.addEventListener('cart:loading', function (e) {
    var filledEl = document.getElementById('cart-filled');
    if (filledEl) {
      filledEl.classList.toggle('is-loading', e.detail === true);
    }
  });

  // Listen for cart updates
  document.addEventListener('cart:updated', function (e) {
    renderCart(e.detail);
  });

  // ── Subscribe & Save Toggle ──────────────────────────────────
  var SUBSCRIBE_CONFIG = {
    discountPercent: 8,
    sellingPlanId: 5718704377,
  };

  var isSubscribing = false; // lock to prevent double-clicks

  function getSellingPlanForItem(item) {
    // Check if this item's product has our selling plan available
    // We look at selling_plan_allocations on the line item
    if (item.selling_plan_allocation) {
      return item.selling_plan_allocation.selling_plan.id;
    }
    return null;
  }

  function isCartSubscribed(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return false;
    // Cart is subscribed if ALL items have a selling_plan_allocation
    return cart.items.every(function (item) {
      return item.selling_plan_allocation != null;
    });
  }

  function calculateSavings(cart) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    cart.items.forEach(function (item) {
      total += item.original_line_price;
    });
    return Math.round(total * SUBSCRIBE_CONFIG.discountPercent / 100);
  }

  function updateSubscribeUI(cart) {
    var checkbox = document.getElementById('cart-subscribe-checkbox');
    var savingsEl = document.getElementById('cart-subscribe-savings');
    var savingsAmountEl = document.getElementById('cart-subscribe-savings-amount');
    var subscribeBox = document.getElementById('cart-subscribe');

    if (!checkbox || !cart || cart.item_count === 0) {
      if (subscribeBox) subscribeBox.style.display = 'none';
      return;
    }

    subscribeBox.style.display = 'block';

    var subscribed = isCartSubscribed(cart);
    checkbox.checked = subscribed;

    if (subscribed && savingsEl && savingsAmountEl) {
      var savings = calculateSavings(cart);
      savingsAmountEl.textContent = window.BundleManager.formatMoney(savings);
      savingsEl.style.display = 'block';
    } else if (savingsEl) {
      savingsEl.style.display = 'none';
    }
  }

  function showStatus(message) {
    var statusEl = document.getElementById('cart-subscribe-status');
    var statusText = document.getElementById('cart-subscribe-status-text');
    var errorEl = document.getElementById('cart-subscribe-error');
    if (errorEl) errorEl.style.display = 'none';
    if (statusEl && statusText) {
      statusText.textContent = message;
      statusEl.style.display = 'flex';
    }
  }

  function hideStatus() {
    var statusEl = document.getElementById('cart-subscribe-status');
    if (statusEl) statusEl.style.display = 'none';
  }

  function showError(message) {
    var errorEl = document.getElementById('cart-subscribe-error');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = 'block';
      // Auto-hide after 8 seconds
      setTimeout(function () {
        if (errorEl) errorEl.style.display = 'none';
      }, 8000);
    }
  }

  async function toggleSubscription(subscribe) {
    if (isSubscribing) return;
    isSubscribing = true;

    var filledEl = document.getElementById('cart-filled');
    if (filledEl) filledEl.classList.add('is-loading');

    showStatus(subscribe ? 'Setting up your subscription...' : 'Removing subscription...');

    // Save original cart for rollback
    var originalCart = null;

    try {
      // 1. Fetch current cart
      var resp = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      originalCart = await resp.json();

      // 2. Build items array
      var items = originalCart.items.map(function (item) {
        var entry = {
          id: item.variant_id,
          quantity: item.quantity,
        };
        if (subscribe) {
          entry.selling_plan = SUBSCRIBE_CONFIG.sellingPlanId;
        }
        // Preserve any line item properties
        if (item.properties && Object.keys(item.properties).length > 0) {
          entry.properties = item.properties;
        }
        return entry;
      });

      // 3. Clear cart
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      // 4. Re-add items
      var addResp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      });

      var addResult = await addResp.json();

      // Check for failure
      if (!addResp.ok || (addResult && addResult.status >= 400)) {
        console.error('Subscribe add failed. Response:', addResult);
        // Rollback: re-add original items WITHOUT selling plan
        var rollbackItems = originalCart.items.map(function (item) {
          var entry = {
            id: item.variant_id,
            quantity: item.quantity,
          };
          if (item.properties && Object.keys(item.properties).length > 0) {
            entry.properties = item.properties;
          }
          return entry;
        });
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: rollbackItems }),
        });
        var errMsg = addResult.description || addResult.message || 'Some items in your cart cannot be subscribed to.';
        throw new Error(errMsg);
      }

      // 5. Get final cart
      var finalResp = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      var finalCart = await finalResp.json();

      hideStatus();
      renderCart(finalCart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: finalCart }));
    } catch (err) {
      console.error('Subscribe toggle error:', err);
      hideStatus();
      showError(err.message || 'Something went wrong. Please try again.');
      var checkbox = document.getElementById('cart-subscribe-checkbox');
      if (checkbox) checkbox.checked = !subscribe;
      // Refresh UI with whatever cart state we have
      try {
        var recoverResp = await fetch('/cart.js');
        var recoverCart = await recoverResp.json();
        renderCart(recoverCart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: recoverCart }));
      } catch (e) {}
    } finally {
      isSubscribing = false;
      if (filledEl) filledEl.classList.remove('is-loading');
    }
  }

  function initSubscribeToggle() {
    var checkbox = document.getElementById('cart-subscribe-checkbox');
    if (!checkbox) return;

    checkbox.addEventListener('change', function () {
      toggleSubscription(this.checked);
    });
  }

  // "Empty Cart" button: confirms, then wipes the cart via BundleManager.
  // The cart:updated event already triggers renderCart() which swaps to the
  // empty-state view, so no extra DOM work needed here.
  function initEmptyCart() {
    var btn = document.getElementById('cart-empty-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (!confirm('Empty your cart? This will remove all items.')) return;
      btn.disabled = true;
      window.BundleManager.clearCart()
        .catch(function (err) {
          console.error('Empty cart error:', err);
          btn.disabled = false;
          alert('Something went wrong. Please try again.');
        });
    });
  }

  // Extend renderCart to also update subscribe UI
  var _origRenderCart2 = renderCart;
  renderCart = function (cart) {
    _origRenderCart2(cart);
    updateSubscribeUI(cart);
  };

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    initSubscribeToggle();
    initEmptyCart();
    window.BundleManager.getCart().then(renderCart);
  });
})();
